import React, { useEffect, useRef, useState } from "react"
import { Typography } from "@kohler-dsm-library/kohler-core"
import styles from "@/components/Remedy/components/ErgonomicsSection/BentoBox/BentoBox.module.scss"
import { handleVideoPlayedAnalytics } from "@/components/Remedy/components/analytics"

export const BentoBox = ({
  title,
  description,
  type,
  videoUrlLarge = "undefined",
  imageUrlLarge = "undefined",
  videoUrlSmall = "undefined",
  imageUrlSmall = "undefined",
  size = "half",
  videoLoop = false,
  videoId = "",
}) => {
  const mediaContainerRef = useRef(null)
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    if (!mediaContainerRef.current) return

    let relevantElement

    if (type === "video") {
      relevantElement = mediaContainerRef.current.querySelector("video")
    } else if (type === "image") {
      relevantElement =
        mediaContainerRef.current.querySelector("picture") ??
        mediaContainerRef.current.querySelector("img")
    }

    if (!relevantElement) return

    const sourceVideo = relevantElement.querySelector("source")

    const handleIntersection = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
          if (type === "video") {
            relevantElement.play()
            handleVideoPlayedAnalytics(
              `${title} - Video`,
              sourceVideo?.src,
              true,
              relevantElement?.id
            )
          }
          observer.unobserve(relevantElement)
          setShowText(true)
        }
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: [0.7],
    })

    observer.observe(relevantElement)

    return () => {
      observer.unobserve(relevantElement)
    }
  }, [])

  return (
    <div
      className={`${styles["bento-box"]} ${styles["bento-box--" + size]}`}
      ref={mediaContainerRef}
    >
      <div
        className={styles["__text-container"]}
        style={{
          opacity: showText ? 1 : 0,
          transform: `translateY(${showText ? 0 : 20}px)`,
        }}
      >
        <Typography
          className={styles["__title"]}
          mod="gray-500"
          size="title-l"
          component="span"
          style={{ fontWeight: 500 }}
        >
          {title}
        </Typography>
        <Typography
          className={styles["__description"]}
          mod="gray-500"
          component="span"
          size="paragraph-medium"
        >
          {description}
        </Typography>
      </div>
      {type === "video" && (
        <div
          className={styles["__media-container"]}
          dangerouslySetInnerHTML={{
            __html: `
              <video
              preload="metadata"
              ${videoLoop ? "loop" : ""}
              muted
              playsinline
              id=${videoId}
            >
              <source
                src="${videoUrlLarge}"
                type="video/mp4"
                media="(min-width: 768px)"
              />
              <source
                src="${videoUrlSmall}"
                type="video/mp4"
                media="(max-width: 768px)"
              />
            </video>
          `,
          }}
        />
      )}
      {type === "image" && (
        <picture>
          <source srcSet={imageUrlLarge} media="(min-width: 768px)" />
          <source srcSet={imageUrlSmall} media="(max-width: 768px)" />
          <img
            className={styles["__media-container"]}
            src={imageUrlLarge}
            alt={title}
          />
        </picture>
      )}
    </div>
  )
}
